import { render, staticRenderFns } from "./GoogleAnalyticsTokens.vue?vue&type=template&id=5bf9d44d"
import script from "./GoogleAnalyticsTokens.vue?vue&type=script&lang=js"
export * from "./GoogleAnalyticsTokens.vue?vue&type=script&lang=js"
import style0 from "./GoogleAnalyticsTokens.vue?vue&type=style&index=0&id=5bf9d44d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports